const regionSelector = () => {
    const regions = window.regionSelector?.regions;
    const currentRegion = document.querySelectorAll('[data-current-region]');
    const regionSelector = document.querySelectorAll('[data-region-selector]');
    if (regions) {
        regions.forEach((region) => {
            if (region.is_current_store) {
                currentRegion?.forEach((div) => {
                    div.innerHTML = region.short_name;
                });
                regionSelector?.forEach((select) => {
                    select.innerHTML = `${select.innerHTML} <option value='${region.domain}' selected="selected">${region.name}</option>`;
                });
            }
            else {
                regionSelector?.forEach((select) => {
                    select.innerHTML = `${select.innerHTML} <option value='${region.domain}'>${region.name}</option>`;
                });
            }
        });
    }
    regionSelector?.forEach((select) => {
        select.addEventListener('change', () => {
            window.location.href = select.value;
        });
    });
};
export { regionSelector };
